module.exports = "<table *ngFor=\"let table of data\">\n  <thead>\n    <tr>\n      <th *ngFor=\"let col of getHead(table)\"> {{ col }}</th>\n    </tr>\n  </thead>\n  <tbody>\n    <tr>\n      <td *ngFor=\"let row of getBody(table)\"> {{ row }} </td>\n    </tr>\n  </tbody>\n</table>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/view/details-blocks/details-blocks.component.html
// module id = ./src/app/view/details-blocks/details-blocks.component.html
// module chunks = main